/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_COSTUME_TYPE_INVENTORY_REPORT = gql`
  query GetCostumeTypeInventoryReport(
    $filter: CostumeTypeInventoryReportFilterInput!
    $options: GetManyOptions
  ) {
    getCostumeTypeInventoryReport(filter: $filter, options: $options) {
      content {
        id
        costumeType
        default
        specialReserve
        sectionSpecific
        total
      }
      count
      limit
      skip
    }
  }
`;

export const GET_PRESENTATIONS = gql`
  query GetPresentations(
    $filter: PresentationFilterInput
    $options: GetManyOptions
  ) {
    getPresentations(filter: $filter, options: $options) {
      content {
        name
        id
        status
        sections {
          id
          name
        }
      }
    }
  }
`;
